<template>
  <el-dialog :title=this.dialogTitle :visible.sync="innerVisible" :close-on-click-modal="false" width="720px" >
    <div class="alertWinBox">
      <!--<AddressSelector :rcpts="rcpts" :persTrees="persTrees" ref="addressSelector" :key="new Date().getTime()"/>-->
      <div class="el-row">
        <div class="mb5">{{$t("wm_lang_html_44c32e")}}</div>
        <div>
          <input type="text" class="el-input__inner" v-model="groupName" />
        </div>
        <div class="el-col el-col-11 mt20">
          <div class="left">
            <div class="el-input el-input--small el-input-group el-input-group--append">
              <label>
                <input type="text" v-bind:value="autocompleteFilterText" v-on:input="onChangeAutocompleteFilterText" autocomplete="off" :placeholder="$i18n.t('wm_lang_d28df0')+'...'" class="el-input__inner">
              </label>
              <div class="el-input-group__append">
                <button @click="clearAutocomplete()" type="button" class="el-button el-button--default" style="padding: 12px;"><i v-show="!enableAutocomplete" class="el-icon-search"/><i v-show="enableAutocomplete" class="el-icon-close"/></button>
              </div>
              <ul v-if="enableAutocomplete" class="ui-corner-all nice_scroll" style="max-height: 356px;">
                <li v-for="(item, index) in autocompleteItems" :key="index" :item="item" @click.prevent="toggleAutocompleteItem(item)">
                  <label class="el-checkbox" :class="{'is-checked': item.selected}">
                                            <span class="el-checkbox__input" :class="{'is-checked': item.selected}"><span class="el-checkbox__inner"/>
                                            <input type="checkbox" aria-hidden="false" class="el-checkbox__original" value=""></span>
                    <span class="el-checkbox__label">{{item.first}}<b>{{item.mid}}</b>{{item.last}}</span>
                  </label>
                </li>
                <li v-if="autocompleteItems.length === 0"><span class="el-checkbox__label note-association">{{$t("wm_lang_html_ab9ed8")}}</span></li>
                <li v-if="autocompleteItems.length >= 200"><span class="el-checkbox__label note-association">{{$t("wm_lang_html_5120e6")}}{{autocompleteItems.length}}{{$t("wm_lang_html_413db9")}}</span></li>
              </ul>
            </div>
            <div class="mt10">
              <div class="el-tabs el-tabs--top el-tabs--border-card">
                <!--<div class="el-tabs__header is-top">-->
                <!--<div class="el-tabs__nav-wrap is-top">-->
                <!--<div class="el-tabs__nav-scroll">-->
                <!--<div role="tablist" class="el-tabs__nav is-top" style="transform: translateX(0px);">-->
                <!--<div id="tab-0" aria-controls="pane-0" role="tab" tabindex="0" class="el-tabs__item is-top is-active" aria-selected="true">{{$t("wm_lang_html_d43e13")}}</div>-->
                <!--<div id="tab-1" aria-controls="pane-1" role="tab" tabindex="-1" class="el-tabs__item is-top">{{$t("wm_lang_html_d3298c")}}</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
                <div role="tabpanel" id="pane-0" aria-labelledby="tab-0" class="el-tab-pane" style="">
                  <TreeView :root="persTrees" :selector="selector" :clickCallback="handleNodeClick" class="p15 nice_scroll"/>
                </div>
                <div role="tabpanel" id="pane-1" aria-labelledby="tab-1" class="el-tab-pane" style="display: none;" aria-hidden="true"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="el-col el-col-2">
          <div class="center">
            <a :title="$i18n.t('wm_lang_153fa6')" @click="addRcpts(selectedRcpts.persons)" class="el-link el-link--primary min100"> <span class="el-link--inner"><i class="el-icon-d-arrow-right"/></span></a>
            <!--<a title=this.$i18n.t('wm_lang_24969a') @click="addRcpts(selectedRcpts.ccs)" class="el-link el-link&#45;&#45;primary"><span class="el-link&#45;&#45;inner"><i class="el-icon-d-arrow-right"/></span></a>-->
            <!--<a title=this.$i18n.t('wm_lang_76ea0d') @click="addRcpts(selectedRcpts.bccs)" class="el-link el-link&#45;&#45;primary"><span class="el-link&#45;&#45;inner"><i class="el-icon-d-arrow-right"/></span></a>-->
          </div>
        </div>
        <div class="el-col el-col-11 mt20">
          <div class="right" style="border-top: 1px solid #e6e6e6;height:400px;">
            <div role="tab" aria-expanded="true" aria-controls="el-collapse-content-8930" aria-describedby="el-collapse-content-8930">
              <div role="button" id="el-collapse-head-8930" tabindex="0" class="el-collapse-item__header is-active">
                {{$t("custom_lang_0038")}}<span id="maxNumDom">(<span id="maxNumTip" class="maxNumTip">{{selectedRcptsCount}}</span>)</span>
                <i class="header-icon el-icon-delete ml10" @click="clearRcpts()"/>
              </div>
            </div>
            <div class="el-collapse-item__content">
              <div>
                <ul class="selected_to selected_person selected_person1 nice_scroll">
                  <li v-for="(rcpt,index) in selectedRcpts.persons" :key="index" @click="removeRcpts(selectedRcpts.persons, index)">{{rcpt.name}}&lt;{{rcpt.email}}&gt;</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancelDialog">{{$t("wm_lang_html_55c3f6")}} {{$t("wm_lang_html_aa4d94")}}</el-button>
      <el-button type="primary" @click="addGroup">{{$t("wm_lang_html_2d7a2f")}} {{$t("wm_lang_html_a7a342")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _ from "lodash";
import TreeUtil from "../core/tree/TreeUtil";
import TreeView from '../core/tree/TreeView.vue';
import OrgContacts from "../core/common/OrgContacts";
import BaseAutocomplete from "../views/member_selector/BaseAutocomplete";
import dialogHandle from "../../utils/dialogHandle";
import BaseContactTree from "../core/common/BaseContactTree";

export default {
    name: "newGroupDialog",
    mixins: [dialogHandle, BaseContactTree, BaseAutocomplete],
    props: {
        getGroupAddData: {
            type: Function,
            default: null
        },
        cancelGroupDialog: {
            type: Function,
            default: null
        },
    },
        data: function () {
          return {
            rcpts: {
              persons: [],
            },
            //选择的收件人、抄送人、密送人
            selectedRcpts: {
              persons: [],
            },
            groupName: '',
            dialogTitle: '',
              disableOrgContact: true
          };
        },
        computed: {
          /**
           * 所有收件人数量
           * @returns {number}
           */
          selectedRcptsCount() {
            return this.selectedRcpts.persons.length;
          }
        },
        components: {
          TreeView,
        },
        created() {
          //回显之前已选的收件人
          this.selectedRcpts.persons = _.concat(this.rcpts.persons);
        },
        methods: {
          addGroup() {
            if (this.getGroupAddData) {
              // this.getGroupAddData(this.$refs.addressSelector.selectedRcpts.persons, this.$refs.addressSelector.groupName);
              this.getGroupAddData(this.selectedRcpts.persons, this.groupName);
            }
            // this.cancelDialog()
          },
          cancelDialog() {
            if (this.cancelGroupDialog) {
              this.cancelGroupDialog();
            }
            this.clearAutocomplete();
            TreeUtil.unSelectAll(this.persTrees, this.selector.selectIds);
            TreeUtil.computeSelectedCount(this.persTrees);
          },
          /**
           * 添加收件人、抄送、密送
           * @param rcpts
           */
          addRcpts(rcpts) {
            let count = OrgContacts.Constant.MAX_RCPT_SELECTED_COUNT - this.selectedRcptsCount;
            if (count > 0) {
              this.autocompleteItems.forEach(function (value) {
                if (value.selected && count-- > 0) {
                  rcpts.push(value);
                }
              });
            }
            if (count > 0) {
              this.selector.selectIds.forEach(function (value) {
                if (count-- > 0) {
                  rcpts.push(value);
                }
              });
            }
              this.clearAutocomplete();
              this.clearSelected();
          },
          /**
           * 移除指定收件人、抄送、密送
           * @param rcpts
           * @param index
           */
          removeRcpts(rcpts, index) {
            if (rcpts && Array.isArray(rcpts) && rcpts.length > 0) {
              rcpts.splice(index, 1);
            }
          },

          /**
           * 清除所有收件人、抄送、密送
           */
          clearRcpts() {
            this.selectedRcpts.persons.splice(0, this.selectedRcpts.persons.length);
          },

          /**
           * 节点点击回调
           */
          handleNodeClick() {
            console.log(this.$i18n.t('wm_lang_b43f83'))
          },
          groupOperAdd() {
            this.selectedRcpts.persons = [];
            this.groupName = '';
            this.dialogTitle = this.$i18n.t('wm_lang_a30c4e');
          },
          groupOperEdit() {
            let pers = this.$store.getters.currGroupData.children.map(({name, email, id}) => ({name, email, id}))
            this.selectedRcpts.persons = pers;
            this.groupName = this.$store.getters.currGroupData.name;
            this.dialogTitle = this.$i18n.t('wm_lang_9aab18');
          },
          newGroupPersTrees(nodes) {
              this.initPersTree(nodes);
          },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sub/newGroupDialog.vue